import * as React from 'react';
import * as ReactDOM from 'react-dom';
import DriversLicenseLookupComponentReact from './DriversLicenseLookupComponentReact';
import { ReactComponent } from 'react-formio';
import settingsForm from './DriversLicenseLookup.settingsForm';

export default class DriversLicenseLookupComponent extends ReactComponent {
  private root: any;
  private component: any;
  private dataValue: any;
  private updateValue: any;
  private id: string;
  private on: Function;
  private error: any;
  private reactInstance: DriversLicenseLookupComponentReact;

  static schema(...extend) {
    const schema = ReactComponent.schema(
      {
        type: 'driversLicenseLookup',
        key: 'driversLicenseLookup',
        label: 'DriversLicense',
        placeholder: 'DriversLicense',
      },
      ...extend
    );
    schema.values = [];
    return schema;
  }

  static get builderInfo() {
    return {
      title: 'Drivers License Lookup',
      group: 'advanced',
      icon: 'puzzle',
      weight: -10,
      schema: DriversLicenseLookupComponent.schema(),
    };
  }

  static editForm = settingsForm;

  focus() {
    if (this.reactInstance) {
      this.reactInstance.focus();
    }
  }

  init() {
    this.on("validationFinished", event => {
      if (this.reactInstance && this.reactInstance.setState) {
        this.reactInstance.setState({ isValid: !this.error });
      }
    });
  }

  attachReact(element) {
    return ReactDOM.render(
      <DriversLicenseLookupComponentReact
        value={this.dataValue}
        component={this.component}
        form={this}
        onChange={this.updateValue}
        isValid={!this.error}
      />,
      element
    );
  }

  detachReact(element) {
    if (element) {
      ReactDOM.unmountComponentAtNode(element);
    }
  }
}
